import React from 'react';
import { Link } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import mapData from '../data/dozynkiMapPoints.json';
import 'leaflet/dist/leaflet.css';
import './DozynkiMap.css';

type DozynkiEvent = {
  name: string;
  date: string;
  endDate?: string;
  time?: string;
  address?: string;
  link?: string;
  multiDay?: boolean;
};

type DozynkiPoint = {
  city: string;
  lat: number;
  lng: number;
  label?: string;
  events: DozynkiEvent[];
};

const grainIcon = L.divIcon({
  className: 'dozynki-marker',
  html: '<div class="dozynki-marker-inner" title="Dożynki">🌾</div>',
  iconSize: [40, 40],
  iconAnchor: [20, 36],
  popupAnchor: [0, -32],
});

function formatDateRange(ev: DozynkiEvent): string {
  if (ev.multiDay && ev.endDate && ev.endDate !== ev.date) {
    return `${ev.date} → ${ev.endDate}`;
  }
  return ev.time ? `${ev.date} ${ev.time}` : ev.date;
}

export default function DozynkiMap() {
  const points = (mapData.points || []) as DozynkiPoint[];
  const center: [number, number] = [52.1, 19.4];

  return (
    <div className="dozynki-page">
      <header className="dozynki-header">
        <div className="dozynki-header-top">
          <Link to="/" className="dozynki-back">
            ← Wróć
          </Link>
          <h1>
            <span aria-hidden="true">🌾</span> Dożynki
          </h1>
        </div>
      </header>

      <div className="dozynki-map-wrap">
        {points.length === 0 ? (
          <div className="dozynki-empty">
            <p>Brak punktów na mapie.</p>
            <p className="dozynki-empty-hint">
              Uruchom <code>npm run dozynki:geocode</code>, żeby wygenerować współrzędne.
            </p>
          </div>
        ) : (
          <MapContainer
            center={center}
            zoom={6}
            minZoom={5}
            maxZoom={14}
            scrollWheelZoom
            className="dozynki-map"
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {points.map((point) => (
              <Marker
                key={`${point.city}-${point.lat}-${point.lng}`}
                position={[point.lat, point.lng]}
                icon={grainIcon}
              >
                <Popup>
                  <div className="dozynki-popup">
                    <strong className="dozynki-popup-city">{point.city}</strong>
                    <ul className="dozynki-popup-list">
                      {point.events.map((ev) => (
                        <li key={`${ev.link}-${ev.name}`}>
                          <div className="dozynki-popup-name">{ev.name}</div>
                          <div className="dozynki-popup-meta">{formatDateRange(ev)}</div>
                          {ev.address ? (
                            <div className="dozynki-popup-addr">{ev.address}</div>
                          ) : null}
                          {ev.link ? (
                            <a href={ev.link} target="_blank" rel="noopener noreferrer">
                              Facebook →
                            </a>
                          ) : null}
                        </li>
                      ))}
                    </ul>
                  </div>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        )}
      </div>
    </div>
  );
}
